import { render, staticRenderFns } from "./CAAG1120.vue?vue&type=template&id=6d2a2c26&scoped=true"
import script from "./CAAG1120Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAAG1120Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAAG1120.vue?vue&type=style&index=0&id=6d2a2c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a2c26",
  null
  
)

export default component.exports